export const merge = <T>(obj1: T, obj2: Partial<T>): T => {
  if (!obj1 || !obj2) return obj1 || (obj2 as T);

  const result: Record<string, unknown> = { ...(obj1 as Record<string, unknown>) };

  Object.entries(obj2).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (typeof value === "object" && !Array.isArray(value) && value !== null) {
      if (result[key] && typeof result[key] === "object" && !Array.isArray(result[key])) {
        result[key] = merge(result[key] as Record<string, unknown>, value as Partial<Record<string, unknown>>);
        return;
      }
    }

    result[key] = value;
  });

  return result as T;
};
